export default __webpack_public_path__ + "static/media/happyInvestBg.df1904ed.png";